// Состояние push на ЭТОМ телефоне — для строки под галочкой в окне «Уведомления» (B-039).
//
// Выбор «присылать push» хранит сервер у человека; здесь — только то, что знает сам
// телефон после последнего подключения: адрес на сервере, но Android не показывает
// уведомления; Google не выдал адрес; всё в порядке. Без этой строки «галочка стоит,
// а push не приходит» выглядело бы так же, как «слетело», и разбирать было бы нечего.
//
// Стор, а не кэш запросов: подключение идёт из хука при входе, из окна и из события
// FCM о смене адреса, а читает результат окно. По образцу `foreground.ts`.

export type PushHereStatus =
  /** Адрес на сервере, уведомления разрешены. */
  | 'connected'
  /** Адрес на сервере, но Android уведомления Рестомаркера не показывает. */
  | 'blocked'
  /** Google не выдал адрес, а сохранённого нет: подключать нечего. */
  | 'failed'
  /** Выбор человека выключен: телефон не подключён намеренно. */
  | 'off';

export type PushHere = {
  readonly status: PushHereStatus;
  /** Разрешение ещё можно спросить (Android в состоянии prompt) — кнопкой в окне. */
  readonly canAsk: boolean;
};

let current: PushHere | null = null;
const listeners = new Set<() => void>();

/**
 * `null` — в этой сессии телефон ещё не подключали. Сбрасывается при смене пары
 * (человек, сессия): чужое «этот телефон получает предупреждения» — неправда.
 */
export function setPushHere(next: PushHere | null): void {
  current = next;
  for (const listener of listeners) listener();
}

export function currentPushHere(): PushHere | null {
  return current;
}

export function subscribePushHere(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
